import { createAction, props } from '@ngrx/store';
import { SearchLocationInput } from '../../models/search-location-input';
import { TadLocation } from 'src/generated/graphql';

export const searchLocations = createAction(
  '[Location ] search locations',
  props<{ input: SearchLocationInput }>()
);
export const searchLocationsSuccess = createAction(
  '[Location ] search locations success',
  props<{ locations: TadLocation[] }>()
);
